export default {
  data() {
    return {
      diabetesTypes: [
        {
          key: "Prediabetes",
          value: 'message.registerReasonPrediabetes'
        },
        {
          key: "Type 2 diabetes",
          value: "message.registerReasonType2Diabetes"
        },
        {
          key: "Type 1 diabetes",
          value: "message.registerReasonType1Diabetes"
        },
        {
          key: 'Gestational diabetes',
          value: "message.registerReasonGestationalDiabetes"
        },
        {
          key: "LADA",
          value: "message.registerReasonLADA"
        },
        {
          key: "MODY",
          value: "message.registerReasonMODY"
        },
        {
          key: "Diabetes insipidus",
          value: "message.registerReasonDiabetesInsipidus"
        },
        {
          key: "General wellbeing",
          value: "message.registerReasonWellbeing\n"
        },
        {
          key: "I am a carer",
          value: "message.registerReasonCarer"
        },
        {
          key: "I am a DSN",
          value: "message.registerReasonDSN"
        },
        {
          key: "I am a doctor",
          value: "message.registerReasonDoctor"
        },
        {
          key: "I am a healthcare professional",
          value: "message.registerReasonHCP"
        },
        {
          key: "Other",
          value: "message.registerReasonOther"
        },
        {
          key: "Parent of child with Type 1 diabetes",
          value: "message.registerReasonParentOfType1"
        },
        {
          key: "Parent of child with Type 2 diabetes",
          value: "message.registerReasonParentOfType2"
        },
        {
          key: "Professional carer",
          value: "message.registerReasonProfessionalCarer"
        },
        {
          key: "Obesity",
          value: "message.registerReasonDiagnosedObesity"
        },
        {
          key: "Overweight",
          value: "message.registerReasonOverweight"
        },
        {
          key: "I have another health condition",
          value: "message.registerReasonAnotherHealthCondition"
        },
        {
          key: "NAFLD",
          value: "message.registerReasonNAFLD"
        }
      ]
    }
  },
  methods: {
    localizeRegistrationReason(key) {
      let self = this;
      let localized = self.diabetesTypes.filter(function (item) {
        return item.key === key;
      });
      if (localized.length === 1) {
        return self.$t(localized[0].value)
      }
      else {
        return key;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Localization/RegisterReasons/index.js